module.exports = __webpack_public_path__ + "static/media/Doughmo.c3b7921a.png";